(function (restored, undefined) {

    restored.get_active_discount = function () {
        // Checks for an active session cookie with a discount code, return the code if i
        var getCookie = function(name) {
            var value = "; " + document.cookie;
            var parts = value.split('; '+name+'=');
            if (parts.length == 2) return parts.pop().split(";").shift();
        };

        return getCookie('discount_code');
    };

}(window.restored = window.restored || {}));


